import React, { useState } from 'react';
import { Box, DataTable } from '../../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import formatDate from '../../../../helpers/formatDate';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import displayCurrency from '../../../../helpers/displayCurrency';
import { Modal } from 'react-bootstrap';
import { Button } from '../../../../common/components/Button/Button';
import ManualConversionForm from '../ManualConversionModal/ManualConversionForm/ManualConversionForm';
import { manualTransactionUpdate, queryTransaction } from '../../redux/accountActions';
import { refreshData } from '../../../../common/components/DataTable/redux/dataTableActions';

const customer = (row, data, extra) => {
  const customerId = row.customer?.data?.id;
  const includedCustomer = extra.find((customer) => customer.id === customerId);
  const customerName = includedCustomer?.attributes?.customer_name ?? '';
  return customerName || '';
};
const quote = (row, data, extra) => {
  const applicationId = row.policy_applications?.data?.[0].id;
  const includedApplication = extra.find(
    (application) => application.id === applicationId,
  );
  if (!includedApplication) {
    return '';
  }
  const status = includedApplication?.attributes?.status;
  return `${includedApplication?.attributes?.quote_reference} | Status: ${status}` ?? '';
};

const formatAmount = (value, row) => displayCurrency(value, row.currency);

const TransactionsList = ({
  extraInfo,
  manualTransactionUpdate,
  queryTransaction,
  goTo,
  refreshData,
}) => {
  const [transactionInfo, setTransactionInfo] = useState(undefined);

  const handleCloseTransactionModal = () => {
    setTransactionInfo(undefined);
  };

  const handleShowTransactionButton = (
    transaction,
    application,
    premiumId,
    quoteReference,
  ) => {
    return Promise.resolve(queryTransaction(transaction.id))
      .then((resp) => {
        const transactions = resp?.meta?.transactions.map((t) => ({
          label: `Reference: ${t.reference} Status: ${t.status} Amount: £${t.amount}`,
          value: t.reference,
        }));

        setTransactionInfo({
          oid: premiumId,
          transactionId: transaction.id,
          quoteReference: quoteReference,
          paymentGatewayTransactions: transactions,
        });
      })
      .catch(() => {
        setTransactionInfo({
          oid: premiumId,
          transactionId: transaction.id,
          quoteReference: quoteReference,
          paymentGatewayTransactions: [],
        });
      });
  };

  const handleManualConversion = (id, values) => {
    return Promise.resolve(manualTransactionUpdate(id, values))
      .then((resp) => {
        setTransactionInfo(undefined);
        goTo(`policies/issued/${resp.meta.policy_id}`);
      })
      .catch(() => {
        setTransactionInfo(undefined);
        refreshData('pendingTransactions');
      });
  };

  const formatActions = (row, data, extra) => {
    const applicationId = row.policy_applications?.data?.[0].id;
    const includedApplication = extra.find(
      (application) => application.id === applicationId,
    );
    if (!includedApplication) {
      return '';
    }
    const attributes = includedApplication.attributes;
    const premiums = includedApplication.relationships?.premiums?.data;

    const premiumId = premiums?.length === 1 ? premiums[0].id : undefined;

    const handleConvert = () => {
      return handleShowTransactionButton(
        data,
        includedApplication,
        premiumId,
        attributes.quote_reference,
      );
    };

    if (attributes.status === 'quote' && attributes.valid === true && premiumId) {
      return (
        <div>
          <Button bsStyle="primary" label="Update Status" handleClick={handleConvert} />
        </div>
      );
    }
    return null;
  };

  const showModal = !!transactionInfo;
  return (
    <Box>
      <DataTable
        source="/policies/transactions"
        name="pendingTransactions"
        showTotal
        // onRowSelect={handleRowSelect}
        autoFilters={[
          {
            type:
              'include=customer,policy_applications,policy_applications.premiums,paym&filter[status]',
            value: 'pending',
          },
        ]}
      >
        <TableHeaderColumn dataField="id" isKey hidden />

        <TableHeaderColumn
          dataField="relationships"
          dataFormat={customer}
          formatExtraData={extraInfo}
        >
          Customer
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="relationships"
          dataFormat={quote}
          formatExtraData={extraInfo}
        >
          Quote
        </TableHeaderColumn>

        <TableHeaderColumn dataField="source" width={'15%'}>
          Source
        </TableHeaderColumn>
        <TableHeaderColumn dataField="amount" width={'10%'} dataFormat={formatAmount}>
          amount
        </TableHeaderColumn>
        <TableHeaderColumn dataField="status" width={'10%'}>
          Status
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="transacted_at"
          dataFormat={formatDate}
          width={'15%'}
        >
          Transacted At
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="relationships"
          width={'10%'}
          dataFormat={formatActions}
          formatExtraData={extraInfo}
        >
          Actions
        </TableHeaderColumn>
      </DataTable>
      <Modal show={showModal} onHide={handleCloseTransactionModal}>
        <Modal.Header closeButton>
          <Modal.Title>Pending Tranaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={'manual-issue-from-transaction-modal'}>
            {showModal && (
              <ManualConversionForm
                onManualConversion={handleManualConversion}
                oid={transactionInfo.oid}
                quoteReference={transactionInfo.quoteReference}
                transactionId={transactionInfo.transactionId}
                transactionOptions={transactionInfo.paymentGatewayTransactions}
                onCancel={handleCloseTransactionModal}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </Box>
  );
};

export default connect(
  (state) => ({
    extraInfo: state?.dataTables?.tables.pendingTransactions?.included ?? [],
  }),
  {
    goTo: push,
    manualTransactionUpdate: manualTransactionUpdate,
    queryTransaction: queryTransaction,
    refreshData: refreshData,
  },
)(TransactionsList);
